import React, { useState } from 'react';
import { motion } from 'motion/react';
import { SectionContent } from '../../Services/UserProjectService';
import { useContentVariation, ProjectTreatment } from '../../hooks/useContentVariation';

interface TextSelectableViewerProps {
  content: SectionContent;
  project?: ProjectTreatment;
  navigationDirection?: 'forward' | 'backward';
}

const TextSelectableViewer: React.FC<TextSelectableViewerProps> = ({ content, project, navigationDirection = 'forward' }) => {
  const { getVariationText } = useContentVariation(project);

  // Extract text options and selected index from content
  let selectedText: string = '';

  if (content && typeof content === 'object') {
    const contentData = (content as any).content;

    if (contentData && contentData.textOptions && Array.isArray(contentData.textOptions)) {
      // Ensure selectedOptionIndex is a valid number and within bounds
      let selectedIndex = 0;
      if (typeof contentData.selectedOptionIndex === 'number' &&
          contentData.selectedOptionIndex >= 0 &&
          contentData.selectedOptionIndex < contentData.textOptions.length) {
        selectedIndex = contentData.selectedOptionIndex;
      }

      const selectedOption = contentData.textOptions[selectedIndex];

      if (selectedOption) {
        // Handle different option formats
        if (typeof selectedOption === 'string') {
          selectedText = selectedOption;
        } else if (selectedOption && typeof selectedOption === 'object') {
          // Use the content variation hook to get the appropriate text
          selectedText = getVariationText(selectedOption);
        }
      }
    } else {
      // Fallback: try to extract text directly from contentData if no textOptions
      if (contentData) {
        selectedText = getVariationText(contentData);
      }
    }
  }

  if (!selectedText) {
    return (
      <motion.div
        initial={{ x: navigationDirection === 'forward' ? 300 : -300, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: navigationDirection === 'forward' ? -300 : 300, opacity: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        className="text-selectable-content"
        style={{
          maxWidth: '100%',
          width: '100%',
          padding: '0 2rem'
        }}
      >
        <div className="alert alert-info">
          No hay contenido de texto disponible.
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ x: navigationDirection === 'forward' ? 300 : -300, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: navigationDirection === 'forward' ? -300 : 300, opacity: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="text-selectable-content"
      style={{
        maxWidth: '100%',
        width: '100%',
        padding: '0 2rem'
      }}
    >
      <div className="selected-text-content">
        <div
          style={{
            fontSize: '1.1rem',
            lineHeight: '1.8'
          }}
          dangerouslySetInnerHTML={{ __html: selectedText }}
        />
      </div>
    </motion.div>
  );
};

export default TextSelectableViewer;